import * as Vue from "vue";
import * as mutations from "./../../mutation-types"

export const fetchNotificationSettings = (store, params) => {
    return axios.get(`/api/notification-settings`, { params })
}

export const toggleNotificationSettings = (store, item) => {
    if(item.id) {
        return updateNotificationSettings(store, item)
    } else {
        return createNotificationSettings(store, item)
    }
}

export const updateNotificationSettings = (store, item) => {
    return axios.patch(`/api/notification-settings/${item.id}`, item)
}

export const createNotificationSettings = (store, item) => {
    return axios.post(`/api/notification-settings/`, item)
}
